import { call, options, params } from './helpers';

export const getTickets = (payload) => call(`/beta/tickets${params(payload)}`);

export const getTicketsWithStats = (payload) =>
	call(`/beta/tickets/stats${params(payload)}`);

export const addTicket = (payload) =>
	call(`/beta/tickets`, options(payload, 'POST'));

export const addTicketPublic = (payload) =>
	call(`/beta/tickets/create-public`, options(payload, 'POST'));

export const getTicket = ({ id }) => call(`/beta/tickets/${id}`);

export const commentOnTicket = ({ id, ...payload }) =>
	call(`/beta/tickets/${id}/comment`, options(payload, 'POST'));

export const closeTicket = ({ id }) =>
	call(`/beta/tickets/${id}/close`, options(null, 'PUT'));

export const openTicket = ({ id }) =>
	call(`/beta/tickets/${id}/open`, options(null, 'PUT'));

export const updateTicket = ({ id, ...payload }) =>
	call(`/beta/tickets/${id}`, options(payload, 'PUT'));

export const deleteTicket = ({ id }) =>
	call(`/beta/tickets/${id}`, options(null, 'DELETE'));

export const addTicketDocuments = ({ id, files, documentIds }) =>
	call(
		`/beta/tickets/${id}/documents`,
		options({ files, documentIds, information: {}, bucket: 'tickets' }, 'POST')
	);

export const deleteTicketDocument = ({ id, documentId }) =>
	call(`/beta/tickets/${id}/document/${documentId}`, options(null, 'DELETE'));

// Checklist Items
export const getTicketChecklist = ({ id }) =>
	call(`/beta/tickets/${id}/checklist`);

export const createChecklistItem = ({ id, ...payload }) =>
	call(`/beta/tickets/${id}/checklist`, options(payload, 'POST'));

export const updateChecklistItem = ({ id, checklistItemId, ...payload }) =>
	call(`/beta/tickets/${id}/checklist/${checklistItemId}`, options(payload, 'PUT'));

export const reorderChecklistItems = ({ id, items }) =>
	call(`/beta/tickets/${id}/checklist/reorder`, options({ items }, 'PUT'));

export const deleteChecklistItem = ({ id, checklistItemId }) =>
	call(`/beta/tickets/${id}/checklist/${checklistItemId}`, options(null, 'DELETE'));

// Statistics
export const getTicketStatistics = ({ id }) =>
	call(`/beta/tickets/${id}/statistics`);
